module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.requirement) ? _c('div', [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.requirement.name))])]), _vm._v(" "), _c('edit-requirement-modal', {
    attrs: {
      "id": _vm.id
    }
  }), _vm._v(" "), _c('move-requirement-modal', {
    attrs: {
      "requirements": [_vm.requirement],
      "modalId": "move-requirement-modal-RequirementsDetail"
    }
  }), _vm._v(" "), _c('delete-requirement-modal', {
    attrs: {
      "requirements": [_vm.requirement],
      "modalId": "delete-requirement-modal-RequirementsDetail"
    }
  }), _vm._v(" "), _c('preview-image-modal', {
    attrs: {
      "modalImageUrl": _vm.modalImageUrl,
      "modalImageFilename": _vm.modalImageFilename
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-view-buttons"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.edit-requirement-modal",
      modifiers: {
        "edit-requirement-modal": true
      }
    }],
    attrs: {
      "variant": "secondary",
      "size": "sm"
    }
  }, [_c('icon', {
    attrs: {
      "name": "pencil"
    }
  }), _vm._v("\n        Edit\n      ")], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.move-requirement-modal-RequirementsDetail",
      modifiers: {
        "move-requirement-modal-RequirementsDetail": true
      }
    }],
    attrs: {
      "variant": "warning",
      "size": "sm"
    }
  }, [_vm._v("\n        Move\n      ")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.delete-requirement-modal-RequirementsDetail",
      modifiers: {
        "delete-requirement-modal-RequirementsDetail": true
      }
    }],
    attrs: {
      "variant": "danger",
      "size": "sm"
    }
  }, [_vm._v("\n        Delete\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Details")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [_c('table', {
    staticClass: "table table-sm requirement-detail-table"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("ID:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.requirement.requirement_type.prefix) + _vm._s(_vm.requirement.display_id ? _vm.requirement.display_id : _vm.requirement.requirement_id))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Type:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.requirement.requirement_type.name) + " Requirement")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Created:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getHumanDate(_vm.requirement.created_at + 'Z')))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Reporter:")]), _vm._v(" "), (_vm.reporter) ? _c('td', [_vm._v("\n                " + _vm._s(_vm.reporter.displayName) + "\n              ")]) : _c('td', {
    staticClass: "help-text"
  }, [_vm._v("None")])]), _vm._v(" "), (!_vm.currentProjectIsGlobal) ? _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Assignee:")]), _vm._v(" "), (_vm.assignee) ? _c('td', [_vm._v("\n                " + _vm._s(_vm.assignee.displayName) + "\n              ")]) : _c('td', {
    staticClass: "help-text"
  }, [_vm._v("None")])]) : _vm._e(), _vm._v(" "), (!_vm.currentProjectIsGlobal) ? _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Status:")]), _vm._v(" "), (_vm.status) ? _c('td', [_c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "primary"
    }
  }, [_vm._v(_vm._s(_vm.status.name) + " ")])], 1) : _c('td', {
    staticClass: "help-text"
  }, [_vm._v("None")])]) : _vm._e(), _vm._v(" "), (!_vm.currentProjectIsGlobal) ? _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Component(s):")]), _vm._v(" "), (_vm.selectedComponents.length > 0) ? _c('td', [_vm._l((_vm.selectedComponents), function(component) {
    return [_c('b-badge', {
      attrs: {
        "pill": "",
        "variant": "secondary"
      }
    }, [_vm._v(_vm._s(component) + " ")]), _vm._v(" "), _vm._t("default")]
  })], 2) : _c('td', {
    staticClass: "help-text"
  }, [_vm._v("None")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.attributes), function(attribute) {
    return _c('tr', [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(attribute.name) + ":")]), _vm._v(" "), (_vm.requirement.attributes[attribute.attribute_id]) ? _c('td', [_vm._v("\n                " + _vm._s(_vm.getCustomAttributeValue(attribute, _vm.requirement.attributes)) + "\n              ")]) : _c('td', {
      staticClass: "help-text"
    }, [_vm._v("None")])])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [(_vm.requirement.description) ? _c('b-form-textarea', {
    attrs: {
      "plaintext": "",
      "max-rows": 6,
      "value": _vm.requirement.description
    }
  }) : _c('span', {
    staticClass: "help-text"
  }, [_vm._v("Click \"Edit\" above to add a description")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Linked requirements")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [(_vm.selectedRequirements.length > 0) ? _c('table', {
    staticClass: "table table-sm requirement-detail-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.selectedRequirements), function(requirement) {
    return _c('tr', [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.goToReq(requirement.requirement_id)
        }
      }
    }, [_vm._v(_vm._s(requirement.requirement_type.prefix) + _vm._s(requirement.display_id ? requirement.display_id : requirement.requirement_id))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(requirement.name))])])
  }))]) : _c('span', {
    staticClass: "help-text"
  }, [_vm._v("Click \"Edit\" above to link requirements")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Linked Issues")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [(_vm.selectedIssues.length > 0) ? _c('table', {
    staticClass: "table table-sm requirement-detail-table"
  }, [_c('thead'), _vm._v(" "), _c('tbody', _vm._l((_vm.selectedIssues), function(issue) {
    return _c('tr', [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": ((_vm.$auth.user().atlassian_base_url) + "/browse/" + (issue.key))
      }
    }, [_vm._v(_vm._s(issue.key))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(issue.fields.summary))]), _vm._v(" "), _c('td', [_c('img', {
      attrs: {
        "src": issue.fields.issuetype.iconUrl
      }
    })])])
  }))]) : _c('span', {
    staticClass: "help-text"
  }, [_vm._v("Click \"Edit\" above to link issues")])])])]), _vm._v(" "), (_vm.$auth.user().installed_on_confluence) ? _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Linked Confluence Content")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [(_vm.selectedContents.length > 0) ? _c('table', {
    staticClass: "table table-sm requirement-detail-table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.selectedContents), function(content) {
    return _c('tr', [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": ((_vm.$auth.user().atlassian_base_url) + "/wiki" + (content._links.webui))
      }
    }, [_vm._v(_vm._s(content.title))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(content.history.lastUpdated.friendlyWhen))]), _vm._v(" "), _c('td', _vm._l((content.history.contributors.publishers.users.map(function (a) { return a.displayName; })), function(displayName, index) {
      return _c('span', [_c('span', [_vm._v(_vm._s(displayName))]), (index + 1 < content.history.contributors.publishers.users.map(function (a) { return a.displayName; }).length) ? _c('span', [_vm._v(", ")]) : _vm._e()])
    }))])
  }))]) : _c('span', {
    staticClass: "help-text"
  }, [_vm._v("Click \"Edit\" above to link Confluence content")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Attachments")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [_c('table', {
    staticClass: "table table-sm requirement-detail-table"
  }, [_c('tbody', _vm._l((_vm.requirement.attachments), function(attachment) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(attachment.original_file_name))]), _vm._v(" "), _c('td', [(_vm.isImageFilename(attachment.original_file_name)) ? _c('span', {
      staticClass: "button-need-pointer",
      attrs: {
        "title": "Preview"
      },
      on: {
        "click": function($event) {
          _vm.previewFile(attachment)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "search-plus"
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "button-need-pointer",
      attrs: {
        "title": "Download"
      },
      on: {
        "click": function($event) {
          _vm.downloadFile(attachment)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "download"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "button-need-pointer",
      attrs: {
        "title": "Delete"
      },
      on: {
        "click": function($event) {
          _vm.deleteFile(attachment)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash-o"
      }
    })], 1)])])
  }))]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "id": "file_input"
    },
    on: {
      "change": function($event) {
        _vm.processFile($event)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Activity")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [_c('table', {
    staticClass: "table table-sm requirement-detail-table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.revisions), function(revision, index) {
    return _c('tr', [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getHumanDate(revision.created_at)))]), _vm._v(" "), (_vm.userLookup[revision.account_id]) ? _c('td', [_vm._v(_vm._s(_vm.userLookup[revision.account_id].displayName))]) : _c('td', {
      staticClass: "help-text"
    }, [_vm._v("None")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(revision.action))]), _vm._v(" "), (revision.changed_fields) ? _c('td', [_vm._l((revision.changed_fields.split(',')), function(changedField) {
      return [_c('b-badge', {
        attrs: {
          "pill": "",
          "variant": "info"
        }
      }, [_vm._v(_vm._s(changedField) + " ")]), _vm._v(" "), _vm._t("default")]
    })], 2) : _c('td', {
      staticClass: "help-text"
    }, [_vm._v("None")])])
  }))])])])])], 1) : (_vm.loading) ? _c('div', [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": "",
      "scale": "5"
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Name")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Last Updated")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Contributors")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Revision")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("User")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Changed Fields")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a5f3d96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RequirementsDetail.vue
// module id = 1004
// module chunks = 1